import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as profileActions from './actions';
import * as otherProfileActions from '../../../../actions/members/members';
import * as commonActions from '../../../../actions/common';
import * as purchaseActions from '../../../../actions/transactions/purchases';
import Loader from '../../../common/elements/Loader';
import { ErrorModal, NoDataErrorPage } from './elements/ui';
import * as Components from './components/index';

class ProfilePage extends Component {

    state = { error : false, okLocation : true };

    componentWillMount() {
        const personId = localStorage.getItem("person_id")
        if ( this.props.params.memberId ){
            this.props.getOtherProfile( this.props.params.memberId, true )
        } else {
            this.props.getProfile(personId)
        };
        this.props.getExpertise();
        this.props.getIndustries();
        this.props.getMarkets();
        this.props.getSectors();
        this.props.getProducts();
        this.props.getProfileComplete( personId );
    }

    componentWillReceiveProps ( nextProps ) {
        if( this.props.params.memberId === nextProps.params.memberId ){ return };
        this.props.getOtherProfile( this.props.params.memberId );
        this.props.getExpertise();
        this.props.getIndustries();
        this.props.getMarkets();
        this.props.getSectors();
        this.props.getProducts();
    }

    componentDidMount() {
        this.unregisterLeaveHook = this.props.router.setRouteLeaveHook( this.props.route, this.routerWillLeave.bind(this) );
    }

    componentWillUnmount() {
        this.unregisterLeaveHook();
        if( this.props.params.memberId ){ this.props.destroyOtherProfile() };
    }

    routerWillLeave = nextLocation => {
        // SCROLLING TO ELEMENT IF FORM IS OPEN
        this.props.aFormIsOpen ? this.scrollToElement() : null;
        const okLocation = nextLocation.pathname.includes('profile');

        if (!okLocation && this.props.aFormIsOpen) {
            this.setState({ okLocation })
            return false;
        }
    };

    scrollToElement = () => {
        const formStandardProfile = document.querySelector('.form-standard-profile');
        const achievements = document.querySelector('.achievements-type');
        const endorsements = document.querySelector('.endorsement-manager');

        !!formStandardProfile ? formStandardProfile.scrollIntoView({ behavior: "smooth", block: "center" }) : null;
        !!achievements & !formStandardProfile ? achievements.scrollIntoView({ behavior: "smooth", block: "center" }) : null;
        !!endorsements & !formStandardProfile ? endorsements.scrollIntoView({ behavior: "smooth", block: "center" }) : null;
    }

    render() {
        if( this.props.profile.ui.isError ){ return <NoDataErrorPage error={ this.props.profile.ui.error.status } /> };
        if( !this.props.profile || this.props.profile.ui.isFetching || !this.props.products ){ return <Loader /> };
        return (
            <article className="profile-page-wrapper">
                { !this.state.okLocation && <ErrorModal onClose={ () => this.setState( { okLocation: true }) } /> }
                <Components.ProfileHeader
                    { ...this.props.params }
                    { ...this.props.profile }
                    industriesDropDownList={ this.props.industries }
                    />
                <Components.ProfileBody
                    { ...this.props.params }
                    { ...this.props.profile }
                    expertiseData={ (({ expertise, industries, markets, sectors }) => ({ expertise, industries, markets, sectors }))( this.props ) }
                    />
            </article>
        )
    }
}

const mapStateToProps = ( state, props ) => ({
    profile: props.params.memberId ? state.members.otherProfile : state.profile,
    expertise: state.expertise.expertise,
    industries: state.industries.industries,
    markets: state.markets.markets,
    sectors: state.sectors.sectors,
    aFormIsOpen: state.profile.forms.editing,
    products: state.transactions.products,
});

const mapDispatchToProps = dispatch => ({
    getProfile: ( personId, guestMode ) => dispatch(profileActions.getProfile( personId, guestMode ) ),
    getOtherProfile: personId => dispatch( otherProfileActions.getOtherProfile( personId ) ),
    getProfileComplete: personId => dispatch(profileActions.getProfileComplete( personId )),
    destroyProfile: () => dispatch(profileActions.destroyProfile()),
    destroyOtherProfile: () => dispatch(otherProfileActions.destroyOtherProfile()),
    getExpertise: () => dispatch(commonActions.expertise.getExpertise()),
    getIndustries: () => dispatch(commonActions.industries.getIndustries()),
    getMarkets: () => dispatch(commonActions.markets.getMarkets()),
    getSectors: () => dispatch(commonActions.sectors.getSectors()),
    getProducts: ( ) => dispatch ( purchaseActions.getProducts( ) ),
});

export default withRouter( connect( mapStateToProps, mapDispatchToProps )( ProfilePage ) );



// WEBPACK FOOTER //
// src/client/components/site/features/profile/ProfilePage.js